const firebase = require('firebase/app')
require('firebase/auth')
//require('firebase/firestore')
require('firebase/functions')

const axios = require('axios')
var base = 'https://us-east1-dash-85d53.cloudfunctions.net'
if(process.env.NODE_ENV === 'production') {
} else {
   base = 'http://localhost:5001/dash-85d53/us-east1'
   console.log('using dev function emulation', base)
}

var firebaseConfig = {
  apiKey: "AIzaSyBbnBDa8A8ZT1rfcIUvnLeIrQWy-HBPYwE",
  authDomain: "dash-85d53.firebaseapp.com",
  databaseURL: "https://dash-85d53.firebaseio.com",
  projectId: "dash-85d53",
  storageBucket: "dash-85d53.appspot.com",
  messagingSenderId: "369619342253",
  appId: "1:369619342253:web:31bdd0891dbe71ebf1c724",
  measurementId: "G-9E7LXX9XG1"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

// firebase utils
//const db = firebase.firestore()
// db.enablePersistence()
//   .catch(function (err) {
//     if (err.code === 'failed-precondition') {
//       // Multiple tabs open, persistence can only be enabled
//       // in one tab at a a time.
//       // ...
//     } else if (err.code === 'unimplemented') {
//       // The current browser does not support all of the
//       // features required to enable persistence
//       // ...
//     }
//   })

const auth = firebase.auth()
const functions = firebase.functions()

var session = {
  user: {},
  ready: false
}

session.ready = new Promise(function (resolve) {
  auth.onAuthStateChanged(function (authorizedUser) {
    console.log('authStateChanged', authorizedUser)
    if (authorizedUser) {
      // session.user.uid = authorizedUser.uid
      session.user.uid = authorizedUser.email
      console.log('user.uid', session.user.uid)
      session.user.email = authorizedUser.email
      authorizedUser.getIdToken(true).then(function (idToken) {
        axios.defaults.headers.common = { 'Authorization': `Bearer ${idToken}` }
        let url = `${base}/user`
        axios.get(url)
          .then((res) => {
            console.log('user', res)
            if (res.data && res.data.name) {
              session.user.name = res.data.name.fullName
              session.user.org = res.data.orgUnitPath
              session.user.email = res.data.primaryEmail
              session.user.username = res.data.primaryEmail.split("@")[0]
              session.user.profile = res.data.user_profile

              session.user.isAdmin = session.user.org.indexOf('admins')
              if (session.user.profile && session.user.profile.role === 'ADMIN') {
                session.user.isAdmin = true
              }

              session.user.isStaff = session.user.org.indexOf('Staff')
              session.user.isStudent = session.user.org.indexOf('Students')
              // console.log('signed in', session.user)


              resolve(session.user)
            } else {
              auth.signOut()
              alert('This account does not have the necessary permissions to access this site. Contact the admin for access.')
            }
          })
          .catch((error) => {
            console.error(error)
          })
      })
    }
  })
})


session.user.getClasses = new Promise(function (resolve) {
  session.ready.then(function (user) {
    let url = `${base}/myClasses`
    axios.get(url)
      .then((res) => {
      console.log(res.data)
      session.user.classes = res.data
      resolve(res.data)
    })
  })
})

// firebase collections
// const settingsCollection = db.collection('settings')

export {
  auth,
  session,
  functions,
  base
}
